import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

// Types `text` one character at a time when it mounts or changes, after `delayMs`;
// reduced motion shows it whole. Characters are code points, so accents never split.
export default function useTyping(text, { delayMs = 0, stepMs = 28 } = {}) {
  const reduced = useReducedMotion();
  const chars = Array.from(text);
  const [count, setCount] = useState(reduced ? chars.length : 0);
  useEffect(() => {
    const total = Array.from(text).length;
    if (reduced) { setCount(total); return undefined; }
    let typed = 0;
    let timer = null;
    setCount(0);
    const start = setTimeout(() => {
      timer = setInterval(() => {
        typed += 1;
        setCount(typed);
        if (typed >= total) clearInterval(timer);
      }, stepMs);
    }, delayMs);
    return () => { clearTimeout(start); clearInterval(timer); };
  }, [text, reduced, delayMs, stepMs]);
  return { typed: chars.slice(0, count).join(''), typing: count < chars.length };
}
